import { Instance } from 'mobx-state-tree';
import { AssignActionStatusDetailsDtoModelBase } from './AssignActionStatusDetailsDtoModel.base';

/* The TypeScript type of an instance of AssignActionStatusDetailsDtoModel */
export interface AssignActionStatusDetailsDtoModelType extends Instance<typeof AssignActionStatusDetailsDtoModel.Type> {}

/* A graphql query fragment builders for AssignActionStatusDetailsDtoModel */
export { selectFromAssignActionStatusDetailsDto, assignActionStatusDetailsDtoModelPrimitives, AssignActionStatusDetailsDtoModelSelector } from './AssignActionStatusDetailsDtoModel.base';

/**
 * AssignActionStatusDetailsDtoModel
 */
export const AssignActionStatusDetailsDtoModel = AssignActionStatusDetailsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
